var exports = {
  "v": "ComposerTimestampPill.module__timestamp___SWdMck",
  "J": "ComposerTimestampPill.module__tooltipHint___SWdMck",
};

module.exports = exports;
